import * as React from 'react';
import { Route } from 'react-router';
import RouteErrorBoundary from '../components/route_error_boundary';

import {
  ITEM_SHOW_ROUTE_PATH,
  ITEM_PREVIEW_PATH,
  ITEM_PREVIEW_CONFIRM_PATH,
} from '../components/shared/constants';

function removeSlugFromId(props) {
  const cleaned = {
    ...props.routeParams,
    id: props.routeParams.id.split('-')[0],
  };

  return { ...props, routeParams: cleaned };
}

function getItemShow(_location, cb) {
  require.ensure(
    [],
    (require) => {
      cb(null, (props) => {
        const Item2Layout = require('../components/item2_layout').default;

        return (
          <RouteErrorBoundary>
            <Item2Layout {...removeSlugFromId(props)} />;
          </RouteErrorBoundary>
        );
      });
    },
    'item-show',
  );
}

export const ItemShowRoute = (
  <Route
    key={ITEM_SHOW_ROUTE_PATH}
    path={ITEM_SHOW_ROUTE_PATH}
    getComponent={getItemShow}
  />
);

export const ItemPreviewRoute = (
  <Route
    key={ITEM_PREVIEW_PATH}
    path={ITEM_PREVIEW_PATH}
    getComponent={getItemShow}
  />
);

export const ItemPreviewConfirmRoute = (
  <Route
    key={ITEM_PREVIEW_CONFIRM_PATH}
    path={ITEM_PREVIEW_CONFIRM_PATH}
    getComponent={getItemShow}
  />
);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/routes/item_show.jsx